import { SnackbarAction } from "notistack";
import { placeService } from "../../services/placeService";
import { SystemEntityCollections } from "../../shared/enums/shared-enums";
import { Place } from "../../types/place";
import { useEntityQueryClient } from "./entityQueryClient";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { extractPlaceViewLink } from "../../components/entitiesReferences/InternalEntityLink";
import usePlaceLogic from "../logic/placeLogic";

const usePlaceQuery = () => {
  const navigate = useNavigate();
  const { defaultPlace, getDisplayName } = usePlaceLogic();
  return useEntityQueryClient<Place>({
    service: placeService,
    collection: SystemEntityCollections.PLACE,
    defaultEntity: defaultPlace,
    snackbarDisplayName: getDisplayName,
    snackbarAction: (data: Place): SnackbarAction => (
      <Button
        variant="text"
        onClick={() => navigate(extractPlaceViewLink(data))}
        sx={{ color: "white" }}
      >
        View Place
      </Button>
    ),
  });
};

export default usePlaceQuery;
